import Vue from 'vue';
import Router from 'vue-router';
import MyAccount from './views/customer/MyAccount.vue';
import SwitchBranch from './views/customer/SwitchBranch.vue';
import SwitchBranchConfirmation from './views/customer/SwitchBranchConfirmation.vue';
import MySettings from './views/customer/Settings.vue';
import MyPreferences from './views/customer/Preferences.vue';
import Introduction from './views/Introduction.vue';
import BillingDetails from './views/customer/BillingDetails.vue';
import PhotofixrOrders from './views/customer/PhotofixrGrid.vue';
import UploadPhotofixrOrders from './views/tools/photoEditor/UploadPhotofixrOrders.vue';
import PhotofixrGrid from './views/tools/photoEditor/PhotofixrGrid.vue';
import EditorPhotofixrOrderDetails from './views/tools/photoEditor/EditorPhotofixrOrdersDetails.vue';
import PDFUploadOrders from './views/customer/InstantPrintGrid.vue';
import AllOrdersGrid from './views/customer/AllOrdersGrid.vue';
import ToolkitOrders from './views/customer/ToolkitGrid.vue';
import BespokeOrders from './views/customer/BespokeGrid.vue';
import InstantMarketingOrders from './views/customer/InstantMarketingGrid.vue';
import Login from './views/Login.vue';
import FinishedRegistration from './views/registration/FinishedRegistration.vue';
import PhotofixrOrdersDetails from './views/customer/PhotofixrOrdersDetails.vue';
import PDFUploadOrdersDetails from './views/customer/InstantPrintOrdersDetails.vue';
import InstantMarketingOrdersDetails from './views/customer/InstantMarketingOrdersDetails.vue';
import Reset from './views/ResetPassword.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import AdminLanding from './views/AdminLanding.vue';
import Contact from './views/Contact.vue';
import AboutUs from './views/AboutUs.vue';
import AdminCustomerGrid from './views/admin/CustomerGrid.vue';
import BillingCustomerGrid from './views/billing/CustomerGrid.vue';
import CreateBillingCustomer from './views/billing/CreateCustomers.vue';
import EmailOrders from './views/customer/EmailGrid.vue';
import AdminOrderGrid from './views/admin/OrderGrid.vue';
import BillingOrderGrid from './views/billing/OrderGrid.vue';
import AdminInvoiceGrid from './views/admin/InvoiceGrid.vue';
import BillingInvoiceGrid from './views/billing/InvoiceGrid.vue';
import BespokeGrid from './views/admin/BespokeGrid.vue';
import EmailGrid from './views/admin/EmailGrid.vue';
import InstantPrint from './views/tools/pdfUpload/InstantPrint.vue';
import InstantPrintAnalysing from './views/tools/pdfUpload/Analysing.vue';
import InstantPrintConfirmation from './views/tools/pdfUpload/Confirmation.vue';
import InstantPrintError from './views/tools/pdfUpload/Error.vue';
import InstantPrintPreview from './views/tools/pdfUpload/Preview.vue';
import InstantPrintProducts from './views/tools/pdfUpload/Products.vue';
import InstantPrintCheckout from './views/tools/pdfUpload/Checkout.vue';
import InstantPrintSelections from './views/tools/pdfUpload/Selections3.vue';
import InstantMarketingHome from './views/tools/instantmarketing/InstantMarketingHome.vue';
import InstantMarketingPlaceOrder from './views/tools/instantmarketing/InstantMarketingPlaceOrder.vue';
import InstantMarketingProfile from './views/tools/instantmarketing/InstantMarketingProfile.vue';
import ToolkitLanding from './views/tools/marketingToolkit/MarketingToolkitLanding.vue';
import PhotofixrServices from './views/tools/photofixr/PhotofixrLanding.vue';
import PhotofixrFixSelection from './views/tools/photofixr/FixSelection.vue';
import PhotofixrCheckout from './views/tools/photofixr/Checkout.vue';
import PhotofixrConfirmation from './views/tools/photofixr/Confirmation.vue';
import PriceProducts from './views/tools/quote/QuoteLanding.vue';
import PriceSelections from './views/tools/quote/QuoteSelection.vue';
import PriceConfirmation from './views/tools/quote/Confirmation.vue';
import BillingViewOrder from './views/billing/ViewOrder.vue';
import AdminViewOrder from './views/admin/ViewOrder.vue';
import CreateBespokeOrder from './views/admin/CreateBespokeOrder.vue';
import Rifat from './views/admin/ViewBespokeOrder.vue';
import AdminViewCustomers from './views/admin/ViewCustomers.vue';
import BillingViewCustomers from './views/billing/ViewCustomers.vue';
import ViewPrices from './views/billing/ViewPrices.vue';
import ViewProducts from './views/billing/ViewProducts.vue';
import CreatePrices from './views/billing/CreatePrices.vue';
import CreateProducts from './views/billing/CreateProducts.vue';
import PriceGrid from './views/billing/PriceGrid.vue';
import ProductGrid from './views/billing/ProductGrid.vue';
import InsightsBespokeReports from './views/insights/BespokeReports.vue';
import InsightsCategorySales from './views/insights/CategorySales.vue';
import InsightsCustomerSales from './views/insights/CustomerSales.vue';
import InsightsCustomerStatus from './views/insights/CustomerStatus.vue';
import InsightsLapsedCustomers from './views/insights/LapsedCustomers.vue';
import InsightsMonthEndTasks from './views/insights/MonthEndTasks.vue';
import InsightsNewCustomerRevenue from './views/insights/NewCustomerRevenue.vue';
import InsightsNewSales from './views/insights/NewSales.vue';
import InsightsProductSales from './views/insights/ProductSales.vue';
import InsightsTerritorySales from './views/insights/TerritorySales.vue';
import InsightsTotalSales from './views/insights/TotalSales.vue';
import Invoices from './views/customer/Invoices.vue';
import Basket from './views/customer/Basket.vue';
import UserGrid from './views/admin/users/UserGrid.vue';
import CreateUser from './views/admin/users/CreateUser.vue';
import ModifyUser from './views/admin/users/ModifyUser.vue';

import Print from './views/productServices/Print.vue';
import Merchandise from './views/productServices/Merchandise.vue';
import LandNewHomes from './views/productServices/LandNewHomes.vue';
import DesignStudio from './views/productServices/studio/DesignStudio.vue';
import OurWork from './views/productServices/studio/OurWork';
import OurWorkShowcase from './views/productServices/studio/OurWorkShowcase';
import Digital from './views/productServices/Digital.vue';
import PriceList from './views/productServices/PriceList.vue';

import DigitalWindowCards from './views/productServices/digital/digitalWindowCards.vue';
import MotionGraphics from './views/productServices/digital/motionGraphics.vue';
import SocialMedia from './views/productServices/digital/socialMedia.vue';
import EmailSignature from './views/productServices/digital/emailSignature.vue';
import WebBanners from './views/productServices/digital/webBanners.vue';
import Microsites from './views/productServices/digital/microsites.vue';
import AnimatedBrochure from './views/productServices/digital/animatedBrochure.vue';

import BannersDisplayCards from './views/productServices/print/bannersDisplayBoards.vue';
import Brochures from './views/productServices/print/brochures.vue';
import CardsInvitations from './views/productServices/print/cardsInvitations.vue';
import FlyersLeaflets from './views/productServices/print/flyersLeaflets.vue';
import Stationery from './views/productServices/print/stationery.vue';
import WindowCardsPosters from './views/productServices/print/windowCardsPosters.vue';

import DirectMail from './views/productServices/DirectMail.vue';
import DocumentFolders from './views/productServices/DocumentFolders.vue';
import DoorDrops from './views/productServices/DoorDrop.vue';
import VouchersDashboard from './views/billing/vouchers/VouchersDashboard.vue';

Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },

  mode: 'history',

  routes: [
    {
      path: '/account/summary',
      name: '/account/summary',
      component: MyAccount,
    },
    {
      path: '/account/switch-branch',
      name: '/account/switch-branch',
      component: SwitchBranch,
    },
    {
      path: '/account/switch-branch/confirmation',
      name: '/account/switch-branch/confirmation',
      component: SwitchBranchConfirmation,
    },
    {
      path: '/account/settings',
      name: '/account/settings',
      component: MySettings,
      props: true,
    },
    {
      path: '/account/settings/preferences',
      name: '/account/settings/preferences',
      component: MyPreferences,
      props: true,
    },
    {
      path: '/admin/summary',
      name: '/admin/summary',
      component: AdminLanding,
    },
    {
      path: '/',
      name: '/',
      component: Introduction,
    },
    {
      path: '/products/print',
      name: '/products/print',
      component: Print,
    },
    {
      path: '/products/print/brochures',
      name: '/products/print/brochures',
      component: Brochures,
    },
    {
      path: '/products/print/cards-and-invitations',
      name: '/products/print/cards-and-invitations',
      component: CardsInvitations,
    },
    {
      path: '/products/print/leaflets-and-flyers',
      name: '/products/print/leaflets-and-flyers',
      component: FlyersLeaflets,
    },
    {
      path: '/products/print/stationery',
      name: '/products/print/stationery',
      component: Stationery,
    },
    {
      path: '/products/print/window-cards-and-posters',
      name: '/products/print/window-cards-and-posters',
      component: WindowCardsPosters,
    },
    {
      path: '/products/digital',
      name: '/products/digital',
      component: Digital,
    },
    {
      path: '/products/digital/digital-window-cards',
      name: '/products/digital/digital-window-cards',
      component: DigitalWindowCards,
    },
    {
      path: '/products/digital/motion-graphics',
      name: '/products/digital/motion-graphics',
      component: MotionGraphics,
    },
    {
      path: '/products/digital/social-media',
      name: '/products/digital/social-media',
      component: SocialMedia,
    },
    {
      path: '/products/digital/email-signature',
      name: '/products/digital/email-signature',
      component: EmailSignature,
    },
    {
      path: '/products/digital/web-banners',
      name: '/products/digital/web-banners',
      component: WebBanners,
    },
    {
      path: '/products/digital/microsites',
      name: '/products/digital/microsites',
      component: Microsites,
    },
    {
      path: '/products/digital/animated-brochure',
      name: '/products/digital/animated-brochure',
      component: AnimatedBrochure,
    },
    {
      path: '/products/merchandise',
      name: '/products/merchandise',
      component: Merchandise,
    },
    {
      path: '/products/print/banners-and-display-boards',
      name: '/products/print/banners-and-display-boards',
      component: BannersDisplayCards,
    },
    {
      path: '/services/land-and-new-homes',
      name: '/services/land-and-new-homes',
      component: LandNewHomes,
    },
    {
      path: '/services/design-studio',
      name: '/services/design-studio',
      component: DesignStudio,
    },
    {
      path: '/services/design-studio/our-work',
      name: '/services/design-studio/our-work',
      component: OurWork,
    },
    {
      path: '/products/price-list',
      name: '/products/price-list',
      component: PriceList,
    },
    {
      path: '/services/design-studio/our-work/showcase',
      name: '/services/design-studio/our-work/showcase',
      component: OurWorkShowcase,
    },
    {
      path: '/services/direct-mail',
      name: '/services/direct-mail',
      component: DirectMail,
    },
    {
      path: '/print/products/document-folders',
      name: '/print/products/document-folders',
      component: DocumentFolders,
    },
    {
      path: '/services/door-drops',
      name: '/services/door-drops',
      component: DoorDrops,
    },
    {
      path: '/basket',
      name: '/basket',
      component: Basket,
    },
    {
      path: '/account/billing',
      name: '/account/billing',
      component: BillingDetails,
    },
    {
      path: '/orders/photofixr',
      name: '/orders/photofixr',
      component: PhotofixrOrders,
    },
    {
      path: '/orders/all',
      name: '/orders/all',
      component: AllOrdersGrid,
    },
    {
      path: '/orders/toolkit',
      name: '/orders/toolkit',
      component: ToolkitOrders,
    },
    {
      path: '/orders/instant-print',
      name: '/orders/instant-print',
      component: PDFUploadOrders,
    },
    {
      path: '/orders/bespoke',
      name: '/orders/bespoke',
      component: BespokeOrders,
    },
    {
      path: '/orders/directmailr',
      name: '/orders/directmailr',
      component: InstantMarketingOrders,
    },
    {
      path: '/orders/email',
      name: '/orders/email',
      component: EmailOrders,
    },
    {
      path: '/orders/photofixr/details',
      name: '/orders/photofixr/details',
      component: PhotofixrOrdersDetails,
      props: true,
    },
    {
      path: '/orders/instant-print/details',
      name: '/orders/instant-print/details',
      component: PDFUploadOrdersDetails,
      props: true,
    },
    {
      path: '/orders/directmailr/details',
      name: '/orders/directmailr/details',
      component: InstantMarketingOrdersDetails,
      props: true,
    },
    {
      path: '/get-price/products',
      name: '/get-price/products',
      component: PriceProducts,
      props: true,
      beforeEnter: (to, from, next) => {
        // RAVD-205 - redirect for saved routes to the instant print
        next('/instant-print');
      },
    },
    {
      path: '/get-price/selections',
      name: '/get-price/selections',
      component: PriceSelections,
      props: true,
    },
    {
      path: '/get-price/confirmation',
      name: '/get-price/confirmation',
      component: PriceConfirmation,
      props: true,
    },
    {
      path: '/directmailr',
      name: '/directmailr',
      component: InstantMarketingHome,
    },
    {
      path: '/directmailr/place-order',
      name: '/directmailr/place-order',
      component: InstantMarketingPlaceOrder,
    },
    {
      path: '/directmailr/profile',
      name: '/directmailr/profile',
      component: InstantMarketingProfile,
    },
    {
      path: '/photofixr',
      name: '/photofixr',
      component: PhotofixrServices,
    },
    {
      path: '/photofixr/upload-orders',
      name: '/photofixr/upload-orders',
      component: UploadPhotofixrOrders,
      props: true,
    },
    {
      path: '/photofixr/orders',
      name: '/photofixr/orders',
      component: PhotofixrGrid,
      props: true,
    },
    {
      path: '/photofixr/orders/details',
      name: '/photofixr/orders/details',
      component: EditorPhotofixrOrderDetails,
      props: true,
    },
    {
      path: '/photofixr/selections',
      name: '/photofixr/selections',
      component: PhotofixrFixSelection,
      props: true,
    },
    {
      path: '/photofixr/checkout',
      name: '/photofixr/checkout',
      component: PhotofixrCheckout,
      props: true,
      // meta: { requiresAuth: true }
    },
    {
      path: '/photofixr/confirmation',
      name: '/photofixr/confirmation',
      component: PhotofixrConfirmation,
      props: true,
    },
    {
      path: '/marketing-toolkit',
      name: '/marketing-toolkit',
      component: ToolkitLanding,
      props: true,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      props: true,
    },
    {
      path: '/registration-finished',
      name: '/registration-finished',
      component: FinishedRegistration,
    },
    {
      path: '/account/reset-password',
      name: '/account/reset-password',
      component: Reset,
      // meta: { requiresAuth: true }
    },
    {
      path: '/forgot-password',
      name: '/forgot-password',
      component: ForgotPassword,
    },
    {
      path: '/contact',
      name: '/contact',
      component: Contact,
    },
    {
      path: '/about',
      name: '/about',
      component: AboutUs,
    },
    {
      path: '/admin/customers',
      name: '/admin/customers',
      component: AdminCustomerGrid,
      props: true,
    },
    {
      path: '/billing/customers',
      name: '/billing/customers',
      component: BillingCustomerGrid,
      props: true,
    },
    {
      path: '/billing/customers/create',
      name: '/billing/customers/create',
      component: CreateBillingCustomer,
      props: true,
    },
    {
      path: '/instant-print',
      name: '/instant-print',
      component: InstantPrint,
      props: true,
    },
    {
      path: '/instant-print/analysing',
      name: '/instant-print/analysing',
      component: InstantPrintAnalysing,
      props: true,
    },
    {
      path: '/instant-print/confirmation',
      name: '/instant-print/confirmation',
      component: InstantPrintConfirmation,
      props: true,
    },
    {
      path: '/instant-print/error',
      name: '/instant-print/error',
      component: InstantPrintError,
      props: true,
    },
    {
      path: '/instant-print/artwork-preview',
      name: '/instant-print/artwork-preview',
      component: InstantPrintPreview,
      props: true,
    },
    {
      path: '/instant-print/products',
      name: '/instant-print/products',
      component: InstantPrintProducts,
      props: true,
    },
    {
      path: '/instant-print/checkout',
      name: '/instant-print/checkout',
      component: InstantPrintCheckout,
      props: true,
    },
    {
      path: '/instant-print/print-selections',
      name: '/instant-print/print-selections',
      component: InstantPrintSelections,
      props: true,
    },
    {
      path: '/admin/customers/details',
      name: '/admin/customers/details',
      component: AdminViewCustomers,
      props: true,
    },
    {
      path: '/billing/customers/details',
      name: '/billing/customers/details',
      component: BillingViewCustomers,
      props: true,
    },
    {
      path: '/email-orders',
      name: 'email-orders',
      component: EmailOrders,
    },
    {
      path: '/admin/users',
      name: '/admin/users',
      component: UserGrid,
      props: true,
    },
    {
      path: '/admin/users/create',
      name: '/admin/users/create',
      component: CreateUser,
      props: true,
    },
    {
      path: '/admin/users/details',
      name: '/admin/users/details',
      component: ModifyUser,
      props: true,
    },
    {
      path: '/admin/orders',
      name: '/admin/orders',
      component: AdminOrderGrid,
      props: true,
    },
    {
      path: '/billing/orders',
      name: '/billing/orders',
      component: BillingOrderGrid,
      props: true,
    },
    {
      path: '/admin/invoices',
      name: '/admin/invoices',
      component: AdminInvoiceGrid,
      props: true,
    },
    {
      path: '/billing/invoices',
      name: '/billing/invoices',
      component: BillingInvoiceGrid,
      props: true,
    },
    {
      path: '/admin/orders/bespoke',
      name: '/admin/orders/bespoke',
      component: BespokeGrid,
      props: true,
    },
    {
      path: '/admin/orders/email',
      name: '/admin/orders/email',
      component: EmailGrid,
      props: true,
    },
    {
      path: '/admin/orders/bespoke/create',
      name: '/admin/orders/bespoke/create',
      component: CreateBespokeOrder,
      props: true,
    },
    {
      path: '/admin/orders/bespoke/details',
      name: '/admin/orders/bespoke/details',
      component: Rifat,
      props: true,
    },
    {
      path: '/billing/orders/details',
      name: '/billing/orders/details',
      component: BillingViewOrder,
      props: true,
    },
    {
      path: '/admin/orders/details',
      name: '/admin/orders/details',
      component: AdminViewOrder,
      props: true,
    },
    {
      path: '/billing/prices',
      name: '/billing/prices',
      component: PriceGrid,
    },
    {
      path: '/billing/prices/details',
      name: '/billing/prices/details',
      component: ViewPrices,
      props: true,
    },
    {
      path: '/billing/prices/create',
      name: '/billing/prices/create',
      component: CreatePrices,
      props: true,
    },
    {
      path: '/billing/products',
      name: '/billing/products',
      component: ProductGrid,
    },
    {
      path: '/billing/products/create',
      name: '/billing/products/create',
      component: CreateProducts,
      props: true,
    },
    {
      path: '/billing/vouchers/dashboard',
      name: '/billing/vouchers/dashboard',
      component: VouchersDashboard,
      props: true,
    },
    {
      path: '/billing/products/details',
      name: '/billing/products/details',
      component: ViewProducts,
      props: true,
    },
    {
      path: '/insights/bespokereports',
      name: '/insights/bespokereports',
      component: InsightsBespokeReports,
    },
    {
      path: '/insights/categorysales',
      name: '/insights/categorysales',
      component: InsightsCategorySales,
    },
    {
      path: '/insights/customersales',
      name: '/insights/customersales',
      component: InsightsCustomerSales,
    },
    {
      path: '/insights/customerstatus',
      name: '/insights/customerstatus',
      component: InsightsCustomerStatus,
    },
    {
      path: '/insights/lapsedcustomers',
      name: '/insights/lapsedcustomers',
      component: InsightsLapsedCustomers,
    },
    {
      path: '/insights/monthendtasks',
      name: '/insights/monthendtasks',
      component: InsightsMonthEndTasks,
    },
    {
      path: '/insights/newcustomerrevenue',
      name: '/insights/newcustomerrevenue',
      component: InsightsNewCustomerRevenue,
    },
    {
      path: '/insights/newsales',
      name: '/insights/newsales',
      component: InsightsNewSales,
    },
    {
      path: '/insights/productsales',
      name: '/insights/productsales',
      component: InsightsProductSales,
    },
    {
      path: '/insights/territorysales',
      name: '/insights/territorysales',
      component: InsightsTerritorySales,
    },
    {
      path: '/insights/totalsales',
      name: '/insights/totalsales',
      component: InsightsTotalSales,
    },
    {
      path: '/account/invoices',
      name: '/account/invoices',
      component: Invoices,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // This is temporary hack to prevent users to visit old /tools/ routes
  if (to.path.includes('/tools/')) {
    next({
      path: to.fullPath.replace('/tools/', '/'),
      replace: true,
    });

    return;
  }

  if (to.path === '/registration-finished') {
    const flag = localStorage.getItem('isFinishedRegistration');

    if (flag) {
      next();
    } else {
      next('/');
    }

    return;
  }

  if (to.path.includes('/services/direct-mail')) {
    next({
      name: '/directmailr',
      replace: true,
    });

    return;
  }

  next();
});

// router.beforeEach((to, from, next) => {
//     console.log('***** outside *****')
//     console.log(to)
//     console.log(from)
//     console.log(next)
//     console.log('***** outside *****')
// if (to.meta.requiresAuth) {
// const authUser = JSON.parse(window.localStorage.getItem('authUser'))

// console.log(document.cookie.split(";"))
// let token = false;

// console.log(token + ' token')
// if (token) {
// console.log('if')
// next()
// } else {
// console.log('***** else *****')
// console.log(to)
// console.log(from)
// console.log(next)
// console.log('***** else *****')
// window.sessionStorage.setItem('_routerFrom', to.name)

// window.sessionStorage.setItem('_triggerLogin', 'true')

// document.getElementById('openLogin').click()

// next({name: '/login'})
// console.log(document.getElementById('openLogin'))
// document.getElementById('openLogin').click()
// }
// }
// next()
// })


export default router;
